import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Trapezoid = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="80" viewBox="0 0 80 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M59.6083 0.589401L79.3756 69.4416H0.30426L20.0716 0.589401"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
